module.exports = __webpack_public_path__ + "img/light-3.277c0229.svg";